import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { map, switchMap, take } from "rxjs/operators";
import { fromAccount, State } from "src/app/store";
import { Routes } from "../constants/routes.constants";
import { Account } from "../models/account";

function byAccountNumberAsc(a: Account, b: Account): number {
  return (
    a.accountNumber.localeCompare(b.accountNumber)
  );
}

@Injectable({
  providedIn: 'root'
})
export class PaymentsGuard implements CanActivate {
  constructor(private router: Router, private store: Store<State>) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.store.select(fromAccount.selectors.selectAccounts).pipe(
        take(1),
        map(accounts => accounts.filter(a => a.cancelled !== true && a.billType?.toLowerCase() !== 'bill mortgagee')),
        map(accounts => accounts.sort(byAccountNumberAsc)),
        switchMap((accounts) => {
          if (
            accounts.findIndex(
              (a) => a.accountNumber === route.params.accountNumber
            ) > -1
          ) {
            return of(true);
          } else if (accounts && accounts.length > 0) {
            const tree = this.router.createUrlTree([
              Routes.payments.path,
              accounts[0].accountNumber,
            ]);
            return of(tree);
          } else {
            const tree = this.router.createUrlTree([Routes.home.path]);
            return of(tree);
          }
        })
      );
  }

}
